import { render } from "./Marukoma.vue?vue&type=template&id=40a58935"
import script from "./Marukoma.vue?vue&type=script&lang=js"
export * from "./Marukoma.vue?vue&type=script&lang=js"

import "./Marukoma.vue?vue&type=style&index=0&id=40a58935&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__